'use client'
import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()

export default function imageLoader({ src, width, quality }: { src: string; width?: number; quality?: number }) {
  return `${publicRuntimeConfig.IMAGE_BASE_URL}${src}?w=${width ?? 48}&q=${quality ?? 75}`
}
